/**
 * Proposed sidebar entries for the catalog feature — a contribution file
 * CLAUDE-A merges into the route registry; nothing self-registers.
 * Permission strings per features/catalog/SPEC.md Routes table.
 */
import { FileUp, LayoutGrid, Package, Receipt, Ruler, Tags } from "lucide-react";

import type { NavEntry } from "@/app-shell/route-registry";

export const catalogNavEntries: NavEntry[] = [
  {
    path: "/catalog",
    labelKey: "nav.catalog",
    icon: LayoutGrid,
    children: [
      {
        path: "/catalog/products",
        labelKey: "nav.catalogProducts",
        icon: Package,
        permission: "catalog.product.read",
      },
      {
        path: "/catalog/attributes",
        labelKey: "nav.catalogAttributes",
        icon: Tags,
        permission: "catalog.attribute.read",
      },
      {
        path: "/catalog/uoms",
        labelKey: "nav.catalogUoms",
        icon: Ruler,
        permission: "catalog.uom.read",
      },
      {
        path: "/catalog/price-lists",
        labelKey: "nav.catalogPriceLists",
        icon: Tags,
        permission: "catalog.price_list.read",
      },
      {
        path: "/catalog/tax-classes",
        labelKey: "nav.catalogTaxClasses",
        icon: Receipt,
        permission: "catalog.tax_class.read",
      },
      {
        path: "/catalog/imports",
        labelKey: "nav.catalogImports",
        icon: FileUp,
        permission: "catalog.import.read",
      },
    ],
  },
];
